import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { NumberScrollerComponent } from '../number-scroller/number-scroller.component';
import { QuantityEditModalData } from './quantity-edit-modal-data';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'mic-quantity-edit-modal',
  imports: [
    MatDialogContent,
    MatDialogActions,
    TranslatePipe,
    NumberScrollerComponent,
    MatDialogClose,
    MatButton,
    MatIcon,
    MatIconButton,
    MatTooltip
  ],
  templateUrl: './quantity-edit-modal.component.html',
  styleUrl: './quantity-edit-modal.component.scss'
})
export class QuantityEditModalComponent {
  /**
   * Data injection
   */
  readonly dialogRef = inject(MatDialogRef<QuantityEditModalComponent>);
  readonly data = inject<QuantityEditModalData>(MAT_DIALOG_DATA);

  /**
   * Modal Data
   */
  truckModel: string = this.data.truckModel;
  month: number = this.data.month;
  year: string = this.data.year;
  modelQuantity: number = this.data.modelQuantity;
  oemArrivals: number = this.data.oemArrivals;

  /**
   * Inputs validation
   */
  modelQuantityValid: boolean = true;
  oemArrivalsValid: boolean = true;

  protected isEditModelQuantityActive(): boolean {
    return this.modelQuantityValid && this.oemArrivalsValid;
  }

  protected editModelQuantity() {
    return {
      modelQuantity: this.modelQuantity,
      oemArrivals: this.oemArrivals
    };
  }

  protected closeModal() {
    this.dialogRef.close();
  }
}
